<template>
  <div class="h-full overflow-auto" :class="$style['landing-background']">
    <PublicLandingHeader
      :title="appSettingsStore.applicationTitle"
      subtitle="Nevada Division of Environmental Protection"
      light
    />

    <PublicLandingContainer class="grid justify-stretch md:justify-center 2xl:max-w-screen-2xl">
      <PublicLandingBackdrop class="2xl:col-span-2 grid grid-cols-1 2xl:grid-cols-2 gap-10" light>
        <PublicLandingOnlineServices
          class="2xl:col-span-2"
          title="Online Services"
          body="The Sustainability Management and Reporting Tool (SMART) offers online recycling and solid waste disposal reporting to the Bureau of Sustainable Materials Management."
        ></PublicLandingOnlineServices>
        <PublicLandingCard>
          <PublicLandingCardSection label="Recycling">
            <PublicLandingList>
              <PublicLandingListItem label="Submit annual recycling reports" />
              <PublicLandingListItem label="View historical recycled and diverted materials" />
              <PublicLandingListItem label="Secure access to your company or agency data" />
            </PublicLandingList>
          </PublicLandingCardSection>
        </PublicLandingCard>
        <PublicLandingCard>
          <PublicLandingCardSection label="Solid Waste Disposal">
            <PublicLandingList>
              <PublicLandingListItem label="Submit quarterly, semi-annual, and annual disposal reports" />
              <PublicLandingListItem label="View historical disposal data" />
              <PublicLandingListItem label="Secure access to your facility data" />
            </PublicLandingList>
          </PublicLandingCardSection>
        </PublicLandingCard>
      </PublicLandingBackdrop>
    </PublicLandingContainer>

    <MdrnFooter light black-and-white />
  </div>
</template>

<script lang="ts">
import { InitialBadge } from "@modernary/mui/components/badge";
import { BaseButton } from "@modernary/mui/components/button";
import {
  MdrnAttribution,
  MdrnFooter,
  NoneFoundFlag,
  useAppNav,
  useAppSettingsStore,
} from "@modernary/mui/components/common";
import { LoginButton, LogoutButton, RegisterButton } from "@modernary/mui/utils/authentication/buttons";

import { ref, computed, onMounted, watch, defineComponent } from "vue";
import { FaceSmileIcon, PlusIcon } from "@heroicons/vue/24/solid";
import { ChevronRightIcon } from "@heroicons/vue/24/outline";
import { PhoneIcon, EnvelopeIcon } from "@heroicons/vue/20/solid";
import {
  PublicLandingBackdrop,
  PublicLandingCard,
  PublicLandingCardSection,
  PublicLandingContainer,
  PublicLandingHeader,
  PublicLandingLinkCard,
  PublicLandingList,
  PublicLandingListItem,
  PublicLandingOnlineServices,
  PublicLandingParagraph,
} from "@modernary/mui/components/publicLanding";

// Home content for unauth'd users
export default defineComponent({
  name: "HomePublic",
  setup() {
    const appSettingsStore = useAppSettingsStore();

    return { BaseButton, appSettingsStore };
  },
  components: {
    BaseButton,
    InitialBadge,
    LoginButton,
    RegisterButton,
    PlusIcon,
    ChevronRightIcon,
    MdrnAttribution,
    FaceSmileIcon,
    NoneFoundFlag,
    PhoneIcon,
    EnvelopeIcon,
    LogoutButton,
    MdrnFooter,
    PublicLandingCard,
    PublicLandingCardSection,
    PublicLandingList,
    PublicLandingListItem,
    PublicLandingParagraph,
    PublicLandingLinkCard,
    PublicLandingOnlineServices,
    PublicLandingHeader,
    PublicLandingContainer,
    PublicLandingBackdrop,
  },
});
</script>

<style lang="css" module>
.landing-background {
  background-color: #a7bbb9; /* average color from the sky of the bg */
  background-image: url("/images/smart-bg.jpg");
  background-size: cover;
  background-position: center 0;
  background-repeat: no-repeat;
}
</style>
